import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button, Image } from 'react-bootstrap'
import imgDownload from '../../../images/Download_Outline.svg'
import Swal from 'sweetalert2'
import { htmlToPdfmake, pdfMake } from '../../../lib/pdf-make'
import { useSelector } from 'react-redux'
import NavContract from './contract-nav'
import moment from 'moment'
import { updateSalaryAPI } from '../../../services/contract'
import SwalCustom from '../../../alert/swal-custom'
import Error_false from '../../error/error-false'
import { TXTSUCCESS } from '../../../Constants'

export default function ContractCompensitionNav({
  data,
  isCheck1,
  getContractDetail,
  signatureVP,
  signatureEMP,
  signatureCEO,
  signatureVPPD,
  signatureC
}) {
  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = useSelector((state) => state.roleReducer.role)
  const contractNo = searchParams.get('contractNo')
  const code = searchParams.get('code')

  const [resultContractNo, setResultContractNo] = useState([])

  useEffect(() => {
    moment.locale('th')
  }, [orgId, code, contractNo, isCheck1])

  const exportPDF = async (isChecked) => {
    try {
      const html = htmlToPdfmake(
        ContractCompensitionNav ? ContractCompensitionNav : `-`,
        {
          defaultStyles: {}
        }
      )
      const file = pdfMake.createPdf({
        images: {
          imgsky:
            data.org_id === 1
              ? `${window.location.origin}/image/SKY.png`
              : data.org_id === 2
                ? `${window.location.origin}/image/MT.jpg`
                : data.org_id === 3
                  ? `${window.location.origin}/image/ASTRO.png`
                  : data.org_id === 5
                    ? `${window.location.origin}/image/ProInside.png`
                    : `${window.location.origin}/image/White.png`,
          imgWhite: `${window.location.origin}/image/White.png`,
          imgSquare: `${window.location.origin}/image/square.png`,
          imgCheckBox: `${window.location.origin}/image/checkBox.png`,
          imgSignatureEMP:
            signatureEMP?.url || `${window.location.origin}/image/White.png`,
          imgSignaturePD:
            signatureVP?.url || `${window.location.origin}/image/White.png`,
          imgSignatureCEO:
            signatureCEO?.url || `${window.location.origin}/image/White.png`,
          imgSignatureVP:
            signatureVP?.url || `${window.location.origin}/image/White.png`,
          imgSignatureVPPD:
            signatureVPPD?.url || `${window.location.origin}/image/White.png`,
          imgSignatureC:
            signatureC?.url || `${window.location.origin}/image/White.png`
        },

        info: {
          title: 'ใบค่าตอบแทน'
        },
        // watermark: { text: "ตัวอย่าง", opacity: 0.1 },
        header: function (cp, pc, ps) {
          //add logic
          return {
            columns: [
              {
                text: resultContractNo,
                bold: true,
                opacity: 0.5,
                alignment: 'right',
                margin: [0, 20, 20, 0]
              }
            ]
          }
        },
        content: [
          {
            text: '[CONFIDENTIAL]',
            bold: true,
            alignment: 'right',
            color: 'red',
            fontSize: 18,
            margin: [60, -15, -20, 5],

            anotherStyle: {
              italics: false
            }
          },
          {
            image: 'imgsky',
            alignment: 'center',
            width: 60,
            marginTop: -40,
            marginBottom: 15
          },
          {
            text: data?.org_th || '-',
            bold: true,
            alignment: 'center',
            fontSize: 13
          },
          {
            text:
              data?.type_id === 1
                ? 'แจ้งค่าตอบแทนพนักงาน'
                : 'แจ้งค่าตอบแทนพนักงาน(แบบมีกำหนดระยะเวลา)',
            bold: true,
            alignment: 'center',
            fontSize: 10,
            decoration: 'underline'
          },
          {
            text: [
              {
                text: 'เรื่อง        แจ้งค่าตอบแทนพนักงาน',
                bold: false,
                marginLeft: 10
              }
            ],
            alignment: 'left'
          },
          {
            text: [
              {
                text: 'เรียน       ประธานเจ้าหน้าที่บริหาร',
                bold: false
              }
            ],
            alignment: 'left',
            marginBottom: 5
          },
          {
            text: [
              {
                text: '\t\t ข้าพเจ้าขอแจ้งค่าตอบแทนของพนักงาน ชื่อ',
                bold: false,
                marginRight: 3,
                alignment: 'left',
                preserveLeadingSpaces: true
              },
              {
                text: `${data?.title_th || '-'}${data?.name_th || '-'} ${
                  data?.surname_th || '-'
                }`,
                bold: true
              },
              {
                text: ' ตำแหน่ง ',
                bold: false
              },
              {
                text: `${data?.position_th || '-'}`,
                margin: 5,
                bold: true
              },
              {
                text: ' Level ',
                bold: false
              },
              {
                text: `${data?.level_id || '-'} `,
                bold: true
              }
            ],
            alignment: 'left'
          },

          {
            text: [
              {
                text: `${data?.division_th || '-'} `,
                bold: true
              },
              {
                text: `${data?.faction_th || '-'} `,
                bold: true
              },
              {
                text: `${data?.department_th || '-'} `,
                bold: true
              }
            ],
            marginTop: 0
          },
          {
            text: [
              {
                text: '\t\tในกรณีจัดจ้างพนักงานใหม่ กำหนดเริ่มงานในวันที่ ',
                bold: false,
                preserveLeadingSpaces: true
              },
              {
                text:
                  data.type_id === 1
                    ? moment(data.start_date)
                        .add(543, 'year')
                        .format('D MMMM YYYY')
                    : moment(data.start_date)
                        .add(543, 'year')
                        .format('D MMMM YYYY') +
                      ' ถึง ' +
                      moment(data.contract_end)
                        .add(543, 'year')
                        .format('D MMMM YYYY'),
                // data.type_id  === 1 ?
                //   moment(data.start_date)
                //     .add(543, "year")
                //     .format("D MMMM YYYY") || "-"
                //   :   moment(data.start_date)
                //   .add(543, "year")
                //   .format("D MMMM YYYY") || "-" + 'ถึงวันที่'
                bold: true
              },
              {
                text: ' โดยมีรายละเอียดค่าตอบแทนเป็นดังนี้ ',
                bold: false,
                marginRight: 3,
                alignment: 'left',
                preserveLeadingSpaces: true
              }
            ],
            alignment: 'left'
          },

          {
            table: {
              headerRows: 1,
              widths: [250, 250],
              heights: [80, 80],

              body: [
                [
                  {
                    columns: [
                      [
                        {
                          text: 'ระหว่างทดลองงาน ',
                          bold: true,
                          alignment: 'center',
                          preserveLeadingSpaces: true,
                          marginBottom: 40
                        },
                        {
                          text: 'เงินเดือน........................................................บาท/เดือน',
                          bold: false
                          // marginTop: 50
                        },
                        {
                          text: 'ค่าเดินทางเหมาจ่าย.......................................บาท/เดือน',
                          bold: false
                          // marginTop: 50
                        },
                        {
                          text: 'ค่าโทรศัพท์เหมาจ่าย.....................................บาท/เดือน',
                          bold: false
                          // marginTop: 50
                        },
                        {
                          text: 'อื่น ๆ (ระบุ) ..................................................บาท/เดือน',
                          bold: false
                          // marginTop: 50
                        }
                      ]
                    ],
                    lineHeight: 2,
                    marginTop: 10
                  },
                  {
                    stack: [
                      {
                        columns: [
                          [
                            {
                              text: 'ผ่านทดลองงาน       ',
                              bold: true,
                              preserveLeadingSpaces: true,
                              marginTop: 10,
                              marginBottom: 5
                            },
                            [
                              {
                                image: 'imgSquare',
                                width: 10,
                                marginBottom: -12,
                                marginRight: 80
                              },
                              {
                                text: 'ไม่มีการปรับหลังจากผ่านทดลองงาน ',
                                bold: false,
                                preserveLeadingSpaces: true
                              }
                            ],
                            [
                              {
                                image: 'imgSquare',
                                width: 10,
                                marginBottom: -12,
                                marginRight: 80
                              },
                              {
                                text: 'ปรับเพิ่มทันทีเมื่อผ่านทดลองงาน      ',
                                bold: false,
                                preserveLeadingSpaces: true,
                                marginRight: 9,
                                marginBottom: 10
                              }
                            ],
                            {
                              text: 'เงินเดือน........................................................บาท/เดือน',
                              bold: false,
                              lineHeight: 2
                            },
                            {
                              text: 'ค่าเดินทางเหมาจ่าย.......................................บาท/เดือน',
                              bold: false,
                              lineHeight: 2
                            },
                            {
                              text: 'ค่าโทรศัพท์เหมาจ่าย.....................................บาท/เดือน',
                              bold: false,
                              lineHeight: 2
                            },
                            {
                              text: 'อื่น ๆ (ระบุ) ..................................................บาท/เดือน',
                              bold: false,
                              lineHeight: 2
                            }
                          ]
                        ],
                        alignment: 'center'
                      }
                    ]
                  }
                ]
              ]
            },
            marginTop: 10,

            alignment: 'center'
          },

          {
            text: 'จึงเรียนมาเพื่อโปรดพิจารณา',
            bold: false,
            alignment: 'left',
            preserveLeadingSpaces: true,
            marginTop: 20
          },

          {
            table: {
              headerRows: 2,
              widths: [250, 250],
              heights: [100, 100],

              margin: 'auto',
              body: [
                [
                  //VP
                  {
                    stack: [
                      {
                        image: 'imgSignatureVP',
                        width: 120,
                        valign: 'center',
                        alignment: 'center',
                        marginTop: 30,
                        marginBottom: -65
                      },
                      {
                        text: [
                          {
                            text: 'ลงชื่อ.....................................................................',
                            bold: false,
                            alignment: 'center',
                            preserveLeadingSpaces: true
                          }
                        ],
                        marginTop: 50
                      },

                      {
                        text: [
                          // {
                          //   text: "(...........................................................)",
                          // },
                          {
                            text: `( ${
                              signatureVP?.title_th || '                 '
                            } ${signatureVP?.name_th || '                 '} ${
                              signatureVP?.surname_th || '                 '
                            } )`
                          }
                        ],
                        marginTop: 5
                      },

                      {
                        text: [
                          {
                            text: 'ผู้ช่วยผู้อำนวยการฝ่าย/ผู้อำนวยการฝ่าย',
                            // text: signatureVP?.position_th || "-",
                            bold: false,
                            alignment: 'center'
                          }
                        ],
                        marginTop: 5,
                        marginBottom: 10
                      }
                    ],
                    alignment: 'center'
                  },
                  //C
                  {
                    stack: [
                      {
                        image: 'imgSignatureC',
                        width: 120,
                        valign: 'center',
                        alignment: 'center',
                        marginTop: 30,
                        marginBottom: -65
                      },
                      {
                        text: [
                          {
                            text: 'ลงชื่อ.....................................................................',
                            bold: false,
                            preserveLeadingSpaces: true,
                            marginTop: 0
                          }
                        ],
                        marginTop: 50
                      },
                      {
                        text: [
                          {
                            text: `( ${
                              signatureC?.title_th || '                 '
                            } ${signatureC?.name_th || '                 '} ${
                              signatureC?.surname_th || '                 '
                            } )`
                          }
                        ],
                        marginTop: 5
                      },
                      {
                        text: [
                          {
                            text: `รองประธานเจ้าหน้าที่/ประธานเจ้าหน้าที่  (ต้นสังกัด)`,
                            bold: false
                          }
                        ],
                        marginTop: 5,
                        marginBottom: 10
                      }
                    ],
                    alignment: 'center'
                  }
                ],
                [
                  //VPPD
                  {
                    stack: [
                      {
                        text: [
                          {
                            text: 'รับทราบเพื่อดำเนินการต่อไป',
                            bold: false
                          }
                        ],
                        marginTop: 5,
                        marginLeft: 5
                      },
                      {
                        image: 'imgSignatureVPPD',
                        width: 120,
                        valign: 'center',
                        alignment: 'center',
                        marginTop: 20,
                        marginBottom: -55
                      },
                      {
                        text: [
                          {
                            text: 'ลงชื่อ.....................................................................',
                            bold: false,
                            preserveLeadingSpaces: true,
                            alignment: 'center'
                          }
                        ],
                        marginTop: 40
                      },
                      {
                        text: [
                          {
                            text: `( ${
                              signatureVPPD?.title_th || '                 '
                            }${signatureVPPD?.name_th || '                 '} ${
                              signatureVPPD?.surname_th || '                 '
                            } )`,

                            bold: false,
                            alignment: 'center',
                            preserveLeadingSpaces: true
                          }
                        ]
                      },
                      {
                        text: [
                          {
                            text: 'ผู้อำนวยการฝ่ายบริหารและพัฒนาทรัพยากรบุคคล',
                            // text: signatureTO?.position_th || "-",
                            bold: false,
                            alignment: 'center'
                          }
                        ]
                      }
                    ]
                  },
                  //CEO
                  {
                    stack: [
                      {
                        image: 'imgSignatureCEO',
                        width: 120,
                        // alignment: "center",
                        // fit: [100, 100]
                        valign: 'center',
                        alignment: 'center',
                        marginTop: 30,
                        marginBottom: -65
                      },
                      {
                        text: [
                          {
                            text: 'ลงชื่อ..........................................................................',
                            bold: false
                          }
                        ],
                        marginTop: 63
                      },
                      {
                        text: [
                          {
                            // text: "( นายสิทธิเดช  มัยลาภ )",
                            text: `( ${
                              signatureCEO?.title_th || '                 '
                            }${signatureCEO?.name_th || '                 '} ${
                              signatureCEO?.surname_th || '                 '
                            } )`,

                            bold: false,
                            preserveLeadingSpaces: true
                          }
                        ]
                      },
                      {
                        text: [
                          {
                            text: 'ประธานเจ้าหน้าที่บริหาร',
                            // text: signatureCEO?.position_th || "-",
                            bold: false
                          }
                        ]
                      }
                    ],
                    marginBottom: 10,

                    alignment: 'center'
                  }
                ]
              ]
            }
          },
          {
            columns: [
              {
                text: '*** ข้าพเจ้ารับทราบและยอมรับค่าตอบแทนดังอัตราข้างต้น',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true,
                width: 250,
                marginTop: 20
              },
              {
                stack: [
                  {
                    text: 'ลงชื่อ .....................................................พนักงาน',
                    alignment: 'center',
                    marginTop: 40
                  },

                  {
                    text: [
                      {
                        text: `( ${
                          signatureEMP?.title_th || '                 '
                        }${signatureEMP?.name_th || '                 '} ${
                          signatureEMP?.surname_th || '                 '
                        } )`,

                        bold: false,
                        alignment: 'center',

                        preserveLeadingSpaces: true
                      }
                    ],
                    // marginRight: 50,
                    marginTop: 2
                  }
                ]
              }
            ]
          },
          {
            text: [
              {
                text: 'วันที่..................................................',
                bold: false,
                alignment: 'right'
              }
            ],
            marginRight: 65,
            marginTop: 5
          }
        ],
        footer: function (cp, pc, ps) {
          //add logic
          return {
            columns: [
              [
                {
                  text:
                    data.org_th +
                    ' ' +
                    data.address1_th +
                    ' ' +
                    data.address2_th +
                    ' ' +
                    'เบอร์โทร' +
                    ' ' +
                    data.fax_no +
                    '                                                                                                  ' +
                    data.org_en +
                    ' ' +
                    data.address1_en +
                    ' ' +
                    data.address2_en +
                    ' ' +
                    'Fax : ' +
                    ' ' +
                    data.fax_no,
                  color: '#464EA4',
                  fontSize: 7,
                  alignment: 'left',
                  margin: [30, 0, 30, 90],
                  widths: '300'
                }
              ]
            ]
          }
        },

        pageSize: 'A4',
        defaultStyle: {
          fontSize: 9,
          bold: false,
          font: 'THSarabunNew',
          color: '#2A2A2A',
          lineHeight: 1.3,
          alignment: 'justify'
        },
        pageMargins: [40, 50, 40, 30] //ซ้าย บน ขวา ล่าง
      })
      if (isChecked === 1) {
        file.getBlob((blob) => {
          onSubmitEdit(blob)
        })
      } else {
        file.open()
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Fail!',
        text: error,
        customClass: {
          confirmButton: 'btn btn-success'
        }
      })
    }
  }

  const [isSave, setIsSave] = useState(false)

  const updateContract = async (param) => {
    const datas = await updateSalaryAPI(param)
    setIsSave(false)
    if (!datas) return
    if (datas.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getContractDetail()
      })
    } else {
      Error_false(datas)
    }
  }

  const onSubmitEdit = () => {
    const param = { orgId, contractNo }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        updateContract(param)
      }
    })
  }

  const onImport = () => {
    const input = document.createElement('input')
    input.type = 'file'

    input.addEventListener('change', (event) => {
      const file = event.target.files[0]

      if (file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          const buffer = e.target.result

          const pdfDocGenerator = pdfMake.createPdf({
            content: 'Sucessful'
          })
          pdfDocGenerator.getBuffer((pdfBuffer) => {})
        }
        reader.readAsArrayBuffer(file)
      }
    })

    input.click()
  }

  return (
    <>
      <div
        className="p-3 d-flex d-flex justify-content-between bg-white"
        style={{ position: 'sticky', top: '0px' }}
      >
        <span className=" d-flex gap-3  rounded-top pointer-event ">
          <NavContract />
        </span>

        <div className="gap-3 d-flex ">
          {isCheck1 === 1 ? (
            <></>
          ) : (
            <></>
            // <Button
            //   variant="outline-secondary"
            //   style={{ maxHeight: "33px" }}
            //   size="sm"
            //   onClick={() => {
            //     exportPDF(1);
            //   }}
            // >
            //   Confirm
            // </Button>
          )}

          <Button
            onClick={() => {
              exportPDF(2)
            }}
            size="sm"
            style={{ maxHeight: '33px' }}
          >
            <Image
              style={{
                width: '10px',
                marginRight: 5
              }}
              className="mb-1 "
              src={imgDownload}
            />
            Download PDF
          </Button>
        </div>
      </div>
    </>
  )
}
